/** Expected unsupported or incomplete artwork; programming errors remain distinguishable. */
export default class PrintableContentError extends Error {}
